import { render } from "./App.vue?vue&type=template&id=3b0cc9a0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3b0cc9a0&lang=less"

import exportComponent from "/Users/apple/Desktop/project/exchange/topcredit/FGX/20241016/exchange_user_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__